import TopTicker from "./components/TopTicker";
import Masthead from "./components/Masthead";
import CoverHero from "./components/CoverHero";
import HeadlineList from "./components/HeadlineList";
import TopicWall from "./components/TopicWall";
import StoryGrid from "./components/StoryGrid";
import CommentBuzz from "./components/CommentBuzz";
import RankingBoard from "./components/RankingBoard";
import SubscribeStrip from "./components/SubscribeStrip";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <TopTicker />
      <Masthead />
      <main>
        <CoverHero />
        <HeadlineList />
        <TopicWall />
        <StoryGrid />
        <CommentBuzz />
        <RankingBoard />
        <SubscribeStrip />
      </main>
      <SiteFooter />
    </div>
  );
}